import { motion } from "framer-motion";
import { EASE } from "../lib/util";

const parent = { hidden: {}, show: { transition: { staggerChildren: 0.12 } } };
const line = {
  hidden: { y: "108%", rotate: 2 },
  show: { y: "0%", rotate: 0, transition: { duration: 1.15, ease: EASE } },
};

// Masked line-by-line reveal. `start` drives on-load reveals; otherwise reveals in view.
export const MaskLines = ({ lines, as = "h2", start, delay = 0, className = "", lineClassName = "", testId }) => {
  const Tag = motion[as];
  const trigger = start === undefined ? { whileInView: "show", viewport: { once: true, amount: 0.15 } } : { animate: start ? "show" : "hidden" };
  return (
    <Tag
      key={lines.join("|")}
      data-testid={testId}
      className={className}
      initial="hidden"
      variants={{ ...parent, show: { transition: { staggerChildren: 0.12, delayChildren: delay } } }}
      {...trigger}
    >
      {lines.map((l, i) => (
        <span key={l} className="mask-line">
          <motion.span variants={line} className={`block origin-bottom-left ${i % 2 ? lineClassName : ""}`}>
            {l}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const Reveal = ({ children, delay = 0, y = 26, className = "", as = "div", ...rest }) => {
  const Tag = motion[as];
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 1, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export const Eyebrow = ({ children, tone = "dark", className = "" }) => (
  <p className={`eyebrow ${tone === "dark" ? "text-noor-champagne" : "text-noor-gold"} ${className}`}>
    <span className="eyebrow-line" />
    {children}
  </p>
);
